import React from 'react';
import { Link } from 'react-router';
import sortBy from 'lodash/sortBy';
import moment from 'moment';
import Helmet from 'react-helmet';
import { prefixLink } from 'gatsby-helpers';
import access from 'safe-access';
import { config } from 'config';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import profilePic from './photo_optimized.jpg';
import '../static/fonts/fontawesome/style.css';

class SiteIndex extends React.Component {
  render() {
    const pageLinks = [];
    // Sort pages.
    const sortedPages = sortBy(this.props.route.pages, page => access(page, 'data.date')).reverse();
    sortedPages.forEach((page) => {
      if (access(page, 'file.ext') === 'md' && access(page, 'data.layout') === 'post') {
        const title = access(page, 'data.title') || page.path;
        const description = access(page, 'data.description');
        const datePublished = access(page, 'data.date');
        const category = access(page, 'data.category');
        const postReadLink = '<a class="readmore" href=' + prefixLink(page.path) + ' style="display: inline-block;"><i class="fa fa-arrow-right" aria-hidden="true"></i></a>';

        pageLinks.push((
          <div className="blog-post" key={title}>
            <h2><Link style={{ borderBottom: 'none' }} to={prefixLink(page.path)}>{title}</Link></h2>
            <p dangerouslySetInnerHTML={{ __html: description.concat(' ').concat(postReadLink) }} />
            <span className="blog-category">{category}</span>
            <span style={{ padding: '5px' }} />
            <time dateTime={moment(datePublished).format('MMMM D, YYYY')}>
              {moment(datePublished).format('DD MMMM YYYY')}
            </time>
          </div>
        ));
      }
    });

    return (
      <div>
        <Helmet title={config.siteTitle} meta={[
          {"name": "description", "content": config.siteDescr},
          {"property": "twitter:card", "content": "summary"},
          {"property": "twitter:title", "content": config.siteTitle},
          {"property": "twitter:description", "content": config.siteDescr},
          {"property": "twitter:creator", "content": config.twitterUser},
          {"property": "twitter:url", "content": config.canonicalUrl},
          {"property": "twitter:image", "content": prefixLink(profilePic)},
          {"property": "twitter:image:alt", "content": "My profile image"},
          {"property": "og:image", "content": prefixLink(profilePic)}
        ]}/>
        <SiteHeader {...this.props} />
        <div className="content">
          <div className="main">
            <div className="main-inner">
              {pageLinks}
            </div>
          </div>
        </div>
        <SiteFooter {...this.props} />
      </div>
    );
  }
}

SiteIndex.propTypes = {
  route: React.PropTypes.object,
};

export default SiteIndex;



// WEBPACK FOOTER //
// ./index.jsx